module.exports = __webpack_public_path__ + "media/affiliates/badge-fb660ef1.png";